import apiClient from 'apiClient';
import { AxiosPromise } from 'axios';
import { UserDataForSave } from 'screens/Panel/screens/User/screens/Edit/mapper/types';
import { User, UserDataPayload } from 'screens/Panel/screens/User/screens/Edit/api/types';

export const fetchUser = (userId: string): AxiosPromise<User> =>
  apiClient.get(`/api/v1/broker-management/admins/${userId}`);

export const saveUser = (userId: string, payload: UserDataPayload): AxiosPromise<UserDataForSave> =>
  apiClient.post(`/api/v1/broker-management/update-admin/${userId}`, payload);
